module.exports = __webpack_public_path__ + "media/images/top_menu_icon/hotel_groups-68328a16e14ca047129b3277d4b1d11a.png";